// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"964":"css/admin-app.7034","2839":"css/app.7034"}[chunkId] + ".css";
};